import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';

// --- IMPORTS DES STYLES ---
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster'; // Chargement du plugin natif

import { Card, Spin, Typography, Tag, Divider, Space } from 'antd';
import { EnvironmentOutlined, GlobalOutlined, MedicineBoxOutlined } from '@ant-design/icons';
import axiosInstance from '../../services/axiosServicesVisit';

// --- FIX ICONES LEAFLET ---
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
});

const { Text, Title } = Typography;

// --- COMPOSANT INTERNE POUR LE CLUSTERING (SÉCURISÉ) ---
const MapWithClusters = ({ doctors }) => {
    const map = useMap(); // Hook appelé correctement au top level

    useEffect(() => {
        if (!map || !doctors || doctors.length === 0) return;

        // 1. Création du groupe de clusters natif
        const mg = L.markerClusterGroup({
            chunkedLoading: true,
            maxClusterRadius: 50,
            showCoverageOnHover: false
        });

        // 2. Ajout des marqueurs au groupe
        doctors.forEach(doc => {
            if (doc.latitude && doc.longitude) {
                const marker = L.marker([parseFloat(doc.latitude), parseFloat(doc.longitude)], { icon: DefaultIcon });
                
                // Création du contenu du popup en HTML pur pour Leaflet natif
                const popupContent = `
                    <div style="min-width: 160px; font-family: sans-serif;">
                        <b style="font-size: 14px;">Dr. ${doc.firstname} ${doc.lastname}</b><br/>
                        <span style="display: inline-block; background: #e6f7ff; color: #1890ff; border: 1px solid #91d5ff; padding: 2px 8px; border-radius: 4px; font-size: 11px; margin-top: 5px;">
                            ${doc.doctor?.specialty?.name || "Médecin"}
                        </span>
                        <hr style="margin: 8px 0; border: none; border-top: 1px solid #f0f0f0;" />
                        <div style="font-size: 11px; color: #666;">
                            📍 ${doc.address || "Adresse non renseignée"}
                        </div>
                    </div>
                `;
                
                marker.bindPopup(popupContent);
                mg.addLayer(marker);
            }
        });

        // 3. Ajout du groupe à la carte
        map.addLayer(mg);

         if (doctors.length > 0) {
            // Cette ligne calcule la zone occupée par les points
            // et force la carte à zoomer dessus automatiquement.
            map.fitBounds(mg.getBounds(), { padding: [50, 50] });
        }

        // Nettoyage lors de la destruction du composant
        return () => {
            map.removeLayer(mg);
        };
    }, [map, doctors]);

    return null;
};

const TunisiaMap = () => {
    const [doctors, setDoctors] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axiosInstance.get("/v1/persons/map-data") 
            .then(res => setDoctors(res.data || []))
            .catch(err => console.error("Erreur Map:", err))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return (
        <div style={{ textAlign: 'center', padding: '100px', background: '#fff' }}>
            <Spin size="large" tip="Calcul de la cartographie (3000+ points)..." />
        </div>
    );

    return (
        <div style={{ padding: '20px' }}>
            <Card 
                title={<Space><GlobalOutlined style={{ color: '#1890ff' }} /><Title level={4} style={{ margin: 0 }}>Répartition Géographique des Médecins</Title></Space>}
                bordered={false} 
                className="circlebox shadow-sm"
                extra={<Tag color="blue">{doctors.length} médecins localisés</Tag>}
            >
                <MapContainer 
                    center={[33.8, 9.5]} // On descend un peu le centre pour voir tout le pays
                    zoom={6.9}           // Zoom précis pour la Tunisie
                    scrollWheelZoom={true}
                    style={{ height: '800px', width: '50%', borderRadius: '12px', zIndex: 1 }}
                >
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                    
                    <MapWithClusters doctors={doctors} />
                </MapContainer>
            </Card>
        </div>
    );
};

export default TunisiaMap;